<template>
    <v-container fluid>
        <v-row>
            <v-col
                cols="12"
            >
                <v-alert
                    color="light-blue darken-4"
                    dark
                    icon="mdi-file-document-edit-outline"
                    border="top"
                    prominent
                >
                    <v-row align="center">
                        <v-col class="grow text-h4">Tax Declaration Number Claims</v-col>
                    </v-row>
                </v-alert>
            </v-col>

            <v-col
                cols="12"
            >
                <v-alert
                    color="orange darken-2"
                    colored-border
                    icon="mdi-alert-outline"
                    border="top"
                    prominent
                    elevation="6"
                >
                    To avail of services for a specific Real Property Tax Declaration Number for the first time, you must file a claim with the Treasurer’s Office that you are authorized to conduct transactions for this specific Real Property. Provide the last O.R. Number and Total Assesssed Value of the Property for verification.
                </v-alert>
            </v-col>

            <v-col
                cols="12"
            >
                <v-btn
                    text
                    @click="AddNew"
                >
                    <v-icon class="mr-2">mdi-plus</v-icon>New Claim
                </v-btn>
            </v-col>

            <v-col
                cols="12"
            >
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :options.sync="options"
                        :server-items-length="total"
                        :loading="loading"
                        class="elevation-6"
                        fixed-header
                    >
                        <template v-slot:item.message="{ item }">
                            <div style="width: 200px;" class="text-left" v-html="nl2br(item.message)"></div>
                        </template>

                        <template v-slot:item.status="{ item }">
                            {{ Status(item.status) }}
                        </template>

                        <template v-slot:item.files="{ item }">
                            <!-- <template v-for="(file, i) in item.files">
                                <v-chip
                                    :key="`supp-doc-${i}`"
                                    v-if="FileExtension(file) == 'pdf'"
                                    color="green darken-2"
                                    dark
                                    class="mt-1 mr-1 d-inline-block"
                                    :close="parseInt(item.status) == 0"
                                    @click:close="RemoveFile(item, file, i)"
                                    @click="PDFViewer(file)"
                                >
                                    Document #{{ i + 1 }} ({{FileExtension(file).toUpperCase()}})
                                </v-chip>
                                <v-chip
                                    :key="`supp-doc-${i}`"
                                    v-else
                                    color="red darken-2"
                                    dark
                                    class="mt-1 mr-1 d-inline-block"
                                    @click="ViewProfilePhoto(file)"
                                    :close="parseInt(item.status) == 0"
                                    @click:close="RemoveFile(item, file, i)"
                                >
                                    Document #{{ i + 1 }} ({{FileExtension(file).toUpperCase()}})
                                </v-chip>
                            </template> -->

                            <template v-if="item.validids.length > 0">
                                <v-row
                                    dense
                                >
                                    <v-col
                                        cols="12"
                                        class="text-left"
                                    >
                                        <h3>Valid IDs</h3>
                                    </v-col>
                                    <template v-for="(validid, k) of item.validids">
                                        <v-col
                                            cols="12"
                                            :key="`validid-container-${k}`"
                                            class="text-left"
                                        >
                                            <v-chip
                                                color="red darken-2"
                                                dark
                                                small
                                                @click="ViewFile(validid)"
                                            >{{ validid.name }}</v-chip>
                                        </v-col>
                                    </template>
                                </v-row>
                            </template>

                            <template v-if="item.supportingdocs.length > 0">
                                <v-row
                                    dense
                                >
                                    <v-col
                                        cols="12"
                                        class="text-left"
                                    >
                                        <h3>Supporting Documents</h3>
                                    </v-col>
                                    <template v-for="(supportingdoc, k) of item.supportingdocs">
                                        <v-col
                                            cols="12"
                                            :key="`validid-container-${k}`"
                                            class="text-left"
                                        >
                                            <v-chip
                                                color="green darken-2"
                                                dark
                                                small
                                                @click="ViewFile(supportingdoc)"
                                            >{{ supportingdoc.name }}</v-chip>
                                        </v-col>
                                    </template>
                                </v-row>
                            </template>
                        </template>

                        <template v-slot:item.dateadded="{ item }">
                            <div v-html="MomentDate(item.dateadded)" class="text-no-wrap"></div>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <div class="text-no-wrap">
                                <v-btn
                                    v-if="parseInt(item.status) == 0 && item.returned"
                                    text
                                    small
                                    color="blue darken-2"
                                    @click="Edit(item)"
                                >
                                    <v-icon>mdi-lead-pencil</v-icon>
                                </v-btn>

                                <v-btn
                                    v-if="[0, 1].includes(parseInt(item.status))"
                                    text
                                    small
                                    color="red darken-2"
                                    @click="Delete(item)"
                                >
                                    <v-icon>mdi-close-circle-outline</v-icon>
                                </v-btn>

                                <v-btn
                                    v-if="parseInt(item.status) == 2 && item.returned"
                                    text
                                    small
                                    color="blue darken-2"
                                    @click="ViewRemarks(item)"
                                >
                                    <v-icon>mdi-notebook</v-icon>
                                </v-btn>
                            </div>
                        </template>

                        <template v-slot:item.tdn="{ item }">
                            <div v-if="item.tdndetails.length > 0">
                                {{ item.tdnformatted }}
                            </div>
                        </template>
                    </v-data-table>
                </v-card>

                <v-btn
                    text
                    @click="getDataFromApiSync"
                >
                    <v-icon class="mr-2">mdi-refresh</v-icon>Refresh List
                </v-btn>
            </v-col>
        </v-row>

        <v-dialog
            v-model="remarksdialog"
            scrollable
            max-width="450"
            overlay-opacity="0.2"
            persistent
        >
            <v-card>
                <v-card-title class="headline deep-orange darken-1 white--text"><i class="mdi mdi-file-document-edit-outline mr-2"></i>Remarks</v-card-title>

                <v-card-text
                    class="mt-6 mb-6"
                >
                    <v-row dense>
                        <v-col
                            cols="12"
                        >
                            <nl2br tag="p" :text="remarks" />
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions
                    class="deep-orange darken-1"
                >
                    <v-spacer></v-spacer>

                    <v-btn
                        dark
                        color="red darker-4"
                        @click="remarksdialog = false"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="claimform"
            scrollable
            max-width="800"
            overlay-opacity="0.2"
            persistent
        >
            <v-card>
                <v-card-title class="headline deep-orange darken-1 white--text"><i class="mdi mdi-file-document-edit-outline mr-2"></i>Claim Form</v-card-title>

                <v-card-text
                    class="mt-6 mb-6"
                >
                    <v-row dense>
                        <v-col
                            cols="12"
                        >
                            <!-- <v-textarea
                                v-model="claim.message"
                                label="Claim Message"
                                outlined
                                height="100"
                            ></v-textarea> -->

                            <v-select
                                v-model="claim.message"
                                label="Reason for Claim"
                                outlined
                                :items="claimreasons"
                                item-text="text"
                                item-value="value"
                                dense
                            ></v-select>
                        </v-col>

                        <v-col
                            cols="12"
                            class="d-none"
                        >
                            <v-file-input
                                label="Supporting Documents"
                                outlined
                                dense
                                show-size accept="image/jpeg, image/png, application/pdf"
                                @change="FileAttachment"
                                v-model="attachments"
                                prepend-inner-icon="mdi-file-find-outline"
                                multiple
                                chips
                                small-chips
                                counter
                                hint="You can attach one or more file/s. Only JPEG, PNG and PDF files are allowed"
                                persistent-hint
                            ></v-file-input>
                        </v-col>

                        <v-col
                            cols="12"
                            v-if="claim._id.toString().length == 0"
                        >
                            <v-autocomplete
                                v-model="claiming"
                                :items="itemslink"
                                :loading="loading"
                                :search-input.sync="search"
                                item-text="tdnformatted"
                                item-value="TDN_IntKey"
                                label="Search Tax Declaration Number"
                                placeholder="Start typing to Search"
                                prepend-icon="mdi-database-search"
                                @input="ClaimLink"
                                return-object
                            ></v-autocomplete>
                        </v-col>

                        <v-col
                            cols="12"
                            v-if="claiming"
                        >
                            <v-alert type="success" dense>{{ claiming.tdnformatted }}</v-alert>
                        </v-col>

                        <template v-for="(validid, k) in validids">
                            <v-col
                                cols="12"
                                lg="6"
                                xl="6"
                                md="6"
                                :key="`validid-container-${k}`"
                            >
                                <v-file-input
                                    :label="validid.label"
                                    dense
                                    accept="image/jpeg, image/png"
                                    v-model="validid.attachment"
                                    prepend-inner-icon="mdi-file-find-outline"
                                    hint="jpeg and png files only"
                                    persistent-hint
                                    show-size
                                    counter
                                    @focus="FileAttachmentValidIdSelected(k)"
                                    @change="FileAttachmentValidId"
                                ></v-file-input>
                            </v-col>
                        </template>

                        <v-col
                            cols="12"
                            class="mt-3"
                        >
                            <h3>Supporting Documents <v-btn
                                text
                                small
                                @click="supportingdocs.push({
                                    type: null,
                                    attachment: null,
                                    details: {
                                        data: '',
                                        name: '',
                                        size: '',
                                        type: ''
                                    }
                                })"
                            ><v-icon>mdi-plus-thick</v-icon></v-btn></h3>
                        </v-col>

                        <template v-for="(sdoc, k) in supportingdocs">
                            <v-col
                                cols="5"
                                :key="`supporting-doc-container-type-${k}`"
                            >
                                <v-select
                                    label="Select Supporting Document Type"
                                    v-model="sdoc.type"
                                    :items="supportingdoctypes"
                                    item-text="text"
                                    item-value="value"
                                    dense
                                ></v-select>
                            </v-col>

                            <v-col
                                cols="6"
                                :key="`supporting-doc-container-${k}`"
                            >
                                <v-file-input
                                    :label="`Supporting Document #${k + 1}`"
                                    dense
                                    accept="image/jpeg, image/png, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/pdf"
                                    v-model="sdoc.attachment"
                                    prepend-inner-icon="mdi-file-find-outline"
                                    hint="jpeg, png, docx, doc and pdf files only"
                                    persistent-hint
                                    show-size
                                    counter
                                    @focus="FileAttachmentSdocsSelected(k)"
                                    @change="FileAttachmentSdocs"
                                ></v-file-input>
                            </v-col>

                            <v-col
                                cols="1"
                                :key="`supporting-doc-container-remove-${k}`"
                            >
                                <v-btn
                                    text
                                    color="red darken-2"
                                    dark
                                    @click="supportingdocs.splice(k, 1)"
                                >
                                    <v-icon>mdi-trash-can-outline</v-icon>
                                </v-btn>
                            </v-col>
                        </template>

                        <v-col
                            cols="12"
                            class="d-none"
                        >
                            <v-text-field
                                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                                :prepend-inner-icon="'mdi-shield-key-outline'"
                                :type="showPass ? 'text' : 'password'"
                                v-model="forverification.passcode"
                                label="Enter the TDN Passcode"
                                @click:append="showPass = !showPass"
                                :outlined="true"
                            ></v-text-field>
                        </v-col>

                        <v-col
                            cols="12"
                            class="d-none"
                        >
                            <v-text-field
                                outlined
                                v-model="forverification.totalassessedvalue"
                                dense
                                label="Property Assessed Value"
                                type="number"
                            ></v-text-field>
                        </v-col>

                        <v-col
                            cols="12"
                            class="d-none"
                        >
                            <v-text-field
                                outlined
                                v-model="forverification.lastor"
                                dense
                                label="Last payment O.R. Number"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions
                    class="deep-orange darken-1"
                >
                    <v-spacer></v-spacer>

                    <v-btn
                        dark
                        color="red darker-4"
                        @click="claimform = false"
                    >
                        Close
                    </v-btn>

                    <v-btn
                        dark
                        color="green darker-4"
                        @click="SaveChanges"
                        :disabled="(claim.link.toString().length > 0 && claim.message.toString().length > 0 && validids.filter(x => x.attachment !== null).length == 2 && supportingdocs.filter(x => x.attachment !== null && x.type !== null).length > 0) == false"
                    >
                        Submit Claim
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <LightBox
            ref="lightbox"
            :media="lightboxmedia"
            :show-caption="false"
            :show-light-box="false"
        />

        <v-dialog
            v-model="pdf.show"
            scrollable
            max-width="1080"
            overlay-opacity="0.2"
            persistent
            style="z-index: 9999;"
        >
            <v-card>
                <v-card-title class="headline deep-orange darken-1 white--text"><i class="mdi mdi-file-pdf-outline mr-2"></i>PDF Viewer</v-card-title>

                <v-card-text
                    id="pdfcard"
                >
                    <v-card-actions class="justify-center">
                        <v-btn
                            class="mr-2"
                            text
                            :disabled="pdf.page == 1"
                            @click="pdf.page = 1"
                        >
                            First
                        </v-btn>
                        <v-btn
                            class="mr-2"
                            text
                            :disabled="pdf.page == 1"
                            @click="pdf.page--"
                        >
                            Prev
                        </v-btn>
                        Page <input v-model.number="pdf.page" type="number" style="width: 3.5em" class="mx-2 text-center" /> of {{ pdf.pageCount }}
                        <v-btn
                            class="ml-2"
                            text
                            :disabled="pdf.page == pdf.pageCount"
                            @click="pdf.page++"
                        >
                            Next
                        </v-btn>
                        <v-btn
                            class="ml-2"
                            text
                            :disabled="pdf.page == pdf.pageCount"
                            @click="pdf.page = pdf.pageCount"
                        >
                            Last
                        </v-btn>
                    </v-card-actions>

                    <PDF
                        ref="pdfviewer"
                        v-if="pdf.show"
                        :src="pdf.media"
                        @num-pages="pdf.pageCount = $event"
                        :page="pdf.page"
                        @page-loaded="PDFLoaded($event)"
                    ></PDF>
                </v-card-text>

                <v-card-actions
                    class="deep-orange darken-1"
                >
                    <v-spacer></v-spacer>

                    <v-btn 
                        text
                        dark
                        @click="pdf.show = false"
                    >Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import moment from "moment"
import LightBox from 'vue-image-lightbox'
import PDF from 'vue-pdf'
import Nl2br from 'vue-nl2br'

export default {
    name: 'tdnclaims',
    props: ['CheckIfLoggedInInternal'],
    metaInfo: {
        title: 'Digital Tuguegarao - Tax Declaration Number Claims'
    },
    components: {
        LightBox,
        PDF,
        Nl2br,
    },
    data() {
        return {
            remarksdialog: false,
            remarks: '',
            supportingdoctypes: [
                {
                    text: 'Title of Land',
                    value: 'Title of Land'
                },
                {
                    text: 'Deed of Conveyance',
                    value: 'Deed of Conveyance',
                },
                {
                    text: 'Deed of Sale',
                    value: 'Deed of Sale',
                },
                {
                    text: 'Deed of Donation',
                    value: 'Deed of Donation',
                },
                {
                    text: 'Extrajudicial Settlement',
                    value: 'Extrajudicial Settlement',
                },
                {
                    text: 'Court Order',
                    value: 'Court Order',
                },
                {
                    text: 'SPA (Special Power of Attorney)',
                    value: 'SPA',
                },
            ],
            supportingdocs: [],
            validids: [
                {
                    label: 'Valid ID #1',
                    attachment: null,
                    details: {
                        data: '',
                        name: '',
                        size: '',
                        type: ''
                    }
                },
                {
                    label: 'Valid ID #2',
                    attachment: null,
                    details: {
                        data: '',
                        name: '',
                        size: '',
                        type: ''
                    }
                },
            ],
            valididselected: -1,
            supportingdocselected: -1,
            pdfloaded: false,
            pdf: {
                show: false,
                media: [],
                currentPage: 0,
                pageCount: 0,
                page: 1,
            },
            CRM_Interval: null,
            attachments: undefined,
            claim: {
                _id: '',
                type: 'tdn',
                division: 'Assessor',
                message: '',
                link: '',
                files: [],
            },
            claimform: false,
            loadingsearch: false,
            search: null,
            entries: [],
            searchcancel: null,
            citizen: {},
            // list
            loading: false,
            items: [],
            total: 0,
            headers: [
                {
                    text: 'TDN',
                    sortable: false,
                    value: 'tdn',
                    align: 'center',
                },
                {
                    text: 'Reason for Claim',
                    sortable: false,
                    value: 'message',
                    align: 'center',
                },
                {
                    text: 'Supporting Document/s',
                    sortable: false,
                    value: 'files',
                    align: 'center',
                },
                {
                    text: 'Status',
                    sortable: false,
                    value: 'status',
                    align: 'center',
                },
                {
                    text: 'Date Added',
                    sortable: false,
                    value: 'dateadded',
                    align: 'center',
                },
                {
                    text: 'Actions',
                    sortable: false,
                    value: 'actions',
                    align: 'center',
                },
            ],
            options: {},
            employeeajax: null,
            lightboxmedia: [],
            claimreasons: [],
            claimreasonscache: [],
            verifiedclaim: false,
            forverification: {
                lastor: '',
                totalassessedvalue: 0,
                passcode: '',
            },
            claiming: null,
            showPass: false,
        }
    },
    computed: {
        itemslink() {
            return this.entries.map(x => {
                const {
                    displayname,
                    displayaddress,
                    tdnformatted,
                } = this.TDN_Format(x)

                return Object.assign({}, x, { tdnformatted, displayname, displayaddress })
            })
        }
    },
    watch: {
        options: {
            handler () {
                this.getDataFromApi()
                    .then(data => {
                        this.items = data.items
                        this.total = parseInt(data.total)
                    })
            },
            deep: true,
        },
        search () {
            // Items have already been loaded
            // if (this.acitems.length > 0) return

            if(this.searchcancel){
                this.searchcancel.cancel()
                this.loadingsearch = false
            }

            // Items have already been requested
            if (this.loadingsearch) return

            if (!this.search) return

            if (this.search.toString().length == 0) return

            this.loadingsearch = true

            this.searchcancel = axios.CancelToken.source()

            axios({
                method: 'post',
                url: `${this.domain}/op_rpt_search_tdn`,
                data: {
                    search: this.search.toString(),
                }
            })
                .then(response => {
                    this.loadingsearch = false

                    const entries = this.$jwt.decode(response.data.items, this.jwtsecret)

                    this.entries = entries.items

                    // console.log(this.entries)
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => (this.loadingsearch = false))
        },
    },
    methods: {
        ViewFile(f) {
            window.open(`${this.domain}/serve/staticfiles/${f.filepath.toString().replace('public/files/', '')}`)
        },
        ViewRemarks(i) {
            if(i.remarks && i.remarks.toString().length > 0) {
                this.remarks = i.remarks.toString()
                this.remarksdialog = true
            }
        },
        FileAttachmentValidIdSelected(k) {
            this.valididselected = k
        },
        FileAttachmentValidId(d) {
            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = (e) => {
                    resolve(e.target.result)
                }
                reader.onerror = error => reject(error)
            })

            toBase64(d).then(mfile => {
                if(this.validids[this.valididselected]) {
                    this.validids[this.valididselected].details = {
                        data: mfile,
                        name: d.name,
                        size: d.size,
                        type: d.type,
                    }
                }
            }).catch(() => {})
        },
        FileAttachmentSdocsSelected(k) {
            this.supportingdocselected = k
        },
        FileAttachmentSdocs(d) {
            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = (e) => {
                    resolve(e.target.result)
                }
                reader.onerror = error => reject(error)
            })

            toBase64(d).then(mfile => {
                if(this.supportingdocs[this.supportingdocselected]) {
                    this.supportingdocs[this.supportingdocselected].details = {
                        data: mfile,
                        name: d.name,
                        size: d.size,
                        type: d.type,
                    }
                }
            }).catch(() => {})
        },
        ClaimLink(item) {
            this.claim.link = item.TDN_IntKey
        },
        TDN_Format(x) {
            let tdnformatted = x.TDN_IntKey.toString()

            const possiblesuffix = _.padStart(x.DeclarationNo.toString(), 5, '0')
            // const remaining = x.ARPNo.toString()
            // let possibleprefix = _.padStart(x.ARPNo.toString().replace(possiblesuffix, ''), 2, '0')
            // let possibleprefix = _.padStart(_.trimEnd(x.ARPNo.toString(), x.DeclarationNo.toString()), 2, '0')
            const possibleprefix = _.padStart(x.ARPNo.toString().substr(0, x.ARPNo.toString().length - x.DeclarationNo.toString().length), 2, '0')

            // if(x.ARPNo.toString().replace(possiblesuffix, '').toString().length > 2){
            //     possibleprefix = _.padStart(_.trimEnd(x.ARPNo.toString(), x.DeclarationNo.toString()), 2, '0')
            // }

            // console.log(`${x.ARPNo.toString()} ${possiblesuffix} ${possibleprefix}`)
            if(possiblesuffix.toString().length > 0 && possibleprefix.toString().length > 0){
                tdnformatted = `${possibleprefix}-${possiblesuffix}`

                if(x.tdnsuffix.toString().length > 0){
                    tdnformatted = `${tdnformatted}-${x.tdnsuffix}`
                }
            }

            const displaynameaddress = x.DisplayNameAddress.toString().split(';')
            const displayname = _.trim(displaynameaddress[0])
            const displayaddress = _.trim(displaynameaddress[1])

            return {
                displaynameaddress,
                displayname,
                displayaddress,
                tdnformatted,
            }
        },
        Delete(item) {
            this.$emit('ol', true)

            axios({
                method: 'post',
                url: `${this.domain}/crm_claim_remove`,
                data: {
                    _id: item._id,
                    uid: this.citizen._id.toString(),
                }
            })
                .then(response => {
                    this.$emit('ol', false)

                    if(response.data.response){
                        this.$emit('snackbar', {
                            variant: 'success',
                            message: 'Claim has been cancelled',
                        })

                        this.getDataFromApiSync()
                    } else{
                        this.$emit('snackbar', {
                            variant: 'warning',
                            message: response.data.message.toString(),
                        })
                    }
                })
                .catch(() => {
                    this.$emit('ol', false)

                    this.$emit('snackbar', {
                        variant: 'error',
                        message: 'Something went wrong... Try again...'
                    })
                })
        },
        Edit(item) {
            this.Reset()

            this.claim = {
                _id: item._id.toString(),
                type: 'tdn',
                division: 'Assessor',
                message: item.message.toString(),
                link: item.link.toString(),
                files: [],
            }

            this.claimform = true

            const filtered = this.claimreasons.filter(x => {
                return x.value.toString() == item.message.toString()
            })

            if(filtered.length == 0){
                this.claimreasons.push({
                    text: item.message.toString(),
                    value: item.message.toString(),
                })
            }
        },
        PDFViewer(file) {
            this.pdf.media = `${this.domain}/${file.replace('public/files', 'serve/staticfiles')}`
            this.pdf.show = true
            this.pdf.page = 1
        },
        PDFLoaded(event) {
            this.pdf.currentPage = event

            this.pdfloaded = true
        },
        RemoveFile(item, file, index) {
            this.$emit('ol', true)

            axios({
                method: 'post',
                url: `${this.domain}/crm_claim_file_remove`,
                data: {
                    _id: item._id,
                    file,
                    uid: this.citizen._id.toString(),
                }
            })
                .then(response => {
                    this.$emit('ol', false)

                    if(response.data.response){
                        this.$emit('snackbar', {
                            variant: 'success',
                            message: 'File has been deleted',
                        })

                        // this.getDataFromApiSync()
                        item.files.splice(index, 1)
                    } else{
                        this.$emit('snackbar', {
                            variant: 'warning',
                            message: response.data.message.toString(),
                        })
                    }
                })
                .catch(() => {
                    this.$emit('ol', false)

                    this.$emit('snackbar', {
                        variant: 'error',
                        message: 'Something went wrong... Try again...'
                    })
                })
        },
        FileExtension(file) {
            return file.split('.').pop()
        },
        ViewProfilePhoto(img) {
            const _img = `${this.domain}/serve/staticfiles/${img.replace('public/files/', '')}`

            this.lightboxmedia = [{
                thumb: _img,
                src: _img,
            }]

            this.$refs.lightbox.showImage(0)
        },
        MomentDate(dt) {
            return moment(parseInt(dt) * 1000).format('MMM D, YYYY h:mm A')
        },
        Status(status) {
            let stat = 'Pending'

            switch(parseInt(status)) {
                case 1:
                    // stat = 'Approved'
                    stat = 'Claimed'
                    break;
                case 2:
                    stat = 'Disapproved'
                    break;
                case 3:
                    stat = 'Cancelled'
                    break;
            }

            return stat
        },
        FilesAttachmentsHtml(files) {
            return files.map(x => {
                x = x.split('/').pop()

                return x
            }).join('<br />')
        },
        nl2br (str, is_xhtml) {   
            var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';    
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
        },
        Reset() {
            this.attachments = undefined

            this.claiming = null

            this.forverification = {
                lastor: '',
                totalassessedvalue: 0,
            }

            this.claim = {
                _id: '',
                type: 'tdn',
                division: 'Assessor',
                message: '',
                link: '',
                files: [],
            }

            this.claimreasons = _.cloneDeep(this.claimreasonscache).map(x => {
                return {
                    text: x.reason.reason.toString(),
                    value: x.reason.reason.toString(),
                }
            })

            this.validids = [
                {
                    label: 'Valid ID #1',
                    attachment: null,
                    details: {
                        data: '',
                        name: '',
                        size: '',
                        type: ''
                    }
                },
                {
                    label: 'Valid ID #2',
                    attachment: null,
                    details: {
                        data: '',
                        name: '',
                        size: '',
                        type: ''
                    }
                },
            ]

            this.supportingdocs = []
        },
        AddNew() {
            this.Reset()

            this.claimform = true
        },
        async FileAttachment(files) {
            if(files.length == 0){
                this.attachments = undefined
            }

            this.claim.files = []

            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = (e) => resolve(e.target.result)
                reader.onerror = error => reject(error)
            })

            for await (const file of files) {
                toBase64(file).then(mfile => {
                    this.claim.files.push(mfile)
                }).catch(() => {
                    
                })
            }
        },
        VerifyFromTreasury(callback) {
            //https://egov.tuguegaraocity.gov.ph/Treasury/APIS/RPTAPI.php?function=ClaimRPTQuery&TDN_IntKey=2011001C74700&ORNumber=0353413&TotalAssessedValue=218590

            this.$emit('ol', true)

            // TreasuryAPI_TDN_Claim_Checker

            axios({
                method: 'post',
                url: `${this.domain}/op_tdn_claim_checker`,
                data: {
                    tdn: this.claim.link.toString(),
                    orno: this.forverification.lastor.toString(),
                    assessedvalue: parseFloat(this.forverification.totalassessedvalue),
                    // passcode: this.forverification.passcode.toString(),
                    passcode: this.claim.link.toString(),
                }
            })
                .then(response => {
                    this.$emit('ol', false)

                    if(response.data.response){
                        if(response.data.parsed.result){
                            this.verifiedclaim = true

                            callback()
                        } else{
                            this.$emit('snackbar', {
                                variant: 'warning',
                                message: 'Information for claiming this TDN are incorrect',
                            })
                        }
                    } else{
                        this.$emit('snackbar', {
                            variant: 'warning',
                            message: 'Information for claiming this TDN are incorrect',
                        })
                    }
                })
                .catch(() => {
                    this.$emit('ol', false)

                    this.$emit('snackbar', {
                        variant: 'error',
                        message: 'Something went wrong... Try again...'
                    })
                })
        },
        SaveChanges() {
            this.verifiedclaim = false

            // if(this.claim.message.toString().length > 0 && this.claim.link.toString().length > 0 && this.forverification.lastor.toString().length > 0 && parseFloat(this.forverification.totalassessedvalue) >= 0){
            if(this.claim.message.toString().length > 0 && this.claim.link.toString().length > 0 && this.validids.filter(x => x.attachment !== null).length == 2 && this.supportingdocs.filter(x => x.attachment !== null && x.type !== null).length > 0){
                this.VerifyFromTreasury(() => {
                    this.$emit('ol', true)

                    let claimdata = _.cloneDeep(this.claim)
                    claimdata.uid = this.citizen._id.toString()
                    claimdata.verified = this.verifiedclaim
                    claimdata.validids = this.validids.map(x => {
                        return x.details
                    })
                    claimdata.supportingdocs = this.supportingdocs.map(x => {
                        return {
                            details: x.details,
                            type: x.type,
                        }
                    })

                    axios({
                        method: 'post',
                        url: `${this.domain}/crm_claims_process`,
                        data: claimdata
                    })
                        .then(response => {
                            this.$emit('ol', false)

                            if(response.data.response){
                                this.claimform = false

                                this.$emit('snackbar', {
                                    variant: 'success',
                                    message: 'Your claim has been submitted to the Assessors Office. Please wait for a Text or Email message once your claim has been approved and you can proceed with your application.',
                                    // message: 'You claim is successful, you may proceed with your application.'
                                })

                                this.getDataFromApiSync()
                            } else{
                                this.$emit('snackbar', {
                                    variant: 'warning',
                                    message: response.data.message.toString(),
                                })
                            }
                        })
                        .catch(() => {
                            this.$emit('ol', false)

                            this.$emit('snackbar', {
                                variant: 'error',
                                message: 'Something went wrong... Try again...'
                            })
                        })
                })
            }
        },
        getDataFromApiSync() {
            this.getDataFromApi()
                .then(data => {
                    this.items = data.items
                    this.total = parseInt(data.total)
                })
        },
        getDataFromApi() {
            this.loading = true

            return new Promise((resolve) => {
                const { page, itemsPerPage } = this.options
                const start_row = (parseInt(page) - 1) * parseInt(itemsPerPage)

                if(this.employeeajax){
                    this.employeeajax.cancel()
                }

                this.employeeajax = axios.CancelToken.source()

                axios({
                    url: `${this.domain}/crm_claims_list`,
                    method: 'POST',
                    data: {
                        start_row,
                        limit: itemsPerPage,
                        uid: this.citizen._id.toString(),
                        type: this.claim.type.toString(),
                        division: this.claim.division.toString(),
                    },
                    cancelToken: this.employeeajax.token
                })
                    .then(response => {
                        this.loading = false

                        if(response.data.response){
                            setTimeout(() => {
                                const items = this.$jwt.decode(response.data.items, this.jwtsecret)

                                // console.log(items.items)

                                resolve({
                                    items: items.items.map(x => {
                                        if(x.tdndetails.length > 0){
                                            const {
                                                tdnformatted,
                                            } = this.TDN_Format(x.tdndetails[0])

                                            x.tdnformatted = tdnformatted
                                        }

                                        return x
                                    }),
                                    total: response.data.total
                                })
                            }, 500)
                        } else{
                            setTimeout(() => {
                                resolve({
                                    items: [],
                                    total: 0
                                })
                            }, 500)
                        }
                    }).catch(function(err) {
                        console.log(err)

                        resolve({
                            items: [],
                            total: 0
                        })
                    })
            })
        },
        ClaimReasons() {
            axios({
                method: 'post',
                url: `${this.domain}/crm_claim_reasons`,
                data: {
                    type: this.claim.type.toString(),
                    division: this.claim.division.toString(),
                }
            })
                .then(response => {
                    if(response.data.response){
                        const reasons = this.$jwt.decode(response.data.reasons, this.jwtsecret)

                        if(reasons.reasons.length > 0){
                            this.claimreasonscache = _.cloneDeep(reasons.reasons)
                        }
                    }
                })
        }
    },
    mounted() {
        this.CheckIfLoggedInInternal()

        const { user } = this.$jwt.decode(this.$session.get('crmusersessionsignature'), this.jwtsecret)
        user.mobile = user.mobile || ''
        delete user.passwd
        delete user.signature

        this.citizen = _.cloneDeep(user)

        // check
        this.CRM_Interval = setInterval(() => {
            if(!(this.$ls.get('isLoggedIn') && this.$session.exists() && this.$session.get('crmusersessionsignature'))){
                clearInterval(this.CRM_Interval)

                this.$router.push({
                    name: 'login'
                }).catch(()=>{})
            }
        }, 500)

        this.ClaimReasons()
    }
}
</script>